import * as dtos from "@/models/dtos";
import { Permission } from "./Permission";
import { useStore } from "vuex";
import { ContainerUser } from "./ContainerUser";
import { getImageUrl } from "@/utils/getImages";

export class MainContainer {
  store = useStore();
  Theme: dtos.CustomTheme;
  DTO: dtos.ContainerResponse;
  Permissions: Permission[] = [];
  Users: ContainerUser[] = [];
  MessageThanksForApplying: dtos.DynamicProperty;
  MessageAlreadyApplied: dtos.DynamicProperty;
  MessageWrongSSN: dtos.DynamicProperty;
  MessageJobAppliedSuccess: dtos.DynamicProperty;
  MessageMinYearBorn: dtos.DynamicProperty;
  MessageMinYearBornSWE: dtos.DynamicProperty;
  MessageSSNValidSWE: dtos.DynamicProperty;
  MessageAllowedYearsBornSwe: dtos.DynamicProperty;

  MessageFileUploadIsRequired: dtos.DynamicProperty;

  MessageEqualYearBorn: dtos.DynamicProperty;
  MessageAllowedYears: dtos.DynamicProperty;
  MessageApproved: dtos.DynamicProperty;
  MessageValidEmail: dtos.DynamicProperty;

  MessageBECustomGroupValidation: dtos.DynamicProperty;
  MessageMinYearAtStart: dtos.DynamicProperty;
  MessageMinSelectedInGroup: dtos.DynamicProperty;
  MessageMinLength: dtos.DynamicProperty;

  constructor(container: dtos.ContainerResponse) {
    this.DTO = container;
    container?.permissions?.forEach((element) => {
      this.Permissions.push(new Permission(element));
    });
    this.Theme = container.theme;
    this.build();
  }

  getDefaultInterestLabel(): dtos.LabelResponse {
    return this.DTO.labels?.find(
      (px: any) =>
        px.labelType.name.toLowerCase() === "interest" && px.isDefault === true
    );
  }

  getUsers(): Array<ContainerUser> {
    //
    return this.DTO.users.map((px) => new ContainerUser(px, this));
  }
  getUniqueUsers(): Array<ContainerUser> {
    //
    if (this.DTO?.users && this.DTO?.users?.length > 0) {
      const arrayUniqueByKey = [
        ...new Map(
          this.DTO.users.map((item) => [item["email"], item])
        ).values(),
      ];
      return arrayUniqueByKey.map((px) => new ContainerUser(px, this));
    }
  }
  async SaveMetadata(loadedTheme: dtos.CustomTheme) {
    this.DTO.theme = loadedTheme;
    await this.store.dispatch("updateMetadata", this.DTO);
  }

  addProperty(property: dtos.DynamicProperty) {
    const prop = this.DTO?.metadata?.properties?.find(
      (px) => px.key === property.key
    );
    if (typeof undefined === typeof prop)
      this.DTO.metadata.properties.push(property);
  }

  private build() {
    this.MessageThanksForApplying = this.getOrCreate(
      "Hej<br/>Tack för din ansökan!",
      "/messages/thanksforapply",
      "text",
      "Tack för din ansökan"
    );
    this.MessageAlreadyApplied = this.getOrCreate(
      "<b>Enligt våra noteringar har du redan gjort en ansökan till tjänsten.</b>",
      "/messages/job_already_applied",
      "text",
      "Redan sökt tjänst"
    );

    this.MessageWrongSSN = this.getOrCreate(
      "<p><b>Du har angivit ett felaktigt personnummer.</b><br/>Ditt personnummer måste skrivas med 12st siffror.</p>",
      "/messages/job_wrong_ssn",
      "text",
      "Felaktigt personnummer"
    );

    this.MessageJobAppliedSuccess = this.getOrCreate(
      "<p>Hej ##FIRSTNAME##! <br/>Tack för din ansökan!</ p >",
      "/messages/job_applied_success",
      "text",
      "Jobbet sökt"
    );
    this.MessageMinYearBorn = this.getOrCreate(
      "<p><b>Du har angivit ett felaktigt personnummer.</b><br/>Ditt personnummer måste skrivas med 12st siffror.</p>",
      "/messages/minYearBorn",
      "text",
      "Född minst år"
    );

    this.MessageMinYearBornSWE = this.getOrCreate(
      "<p>Du har angivit ett felaktigt personnummer.</b><br/>Ditt personnummer måste skrivas med 12st siffror.</p>",
      "/messages/minYearBornSwe",
      "text",
      "Lägst ålder född"
    );
    this.MessageSSNValidSWE = this.getOrCreate(
      "<h3>Du har angivit ett felaktigt personnummer<h3/><p>Ditt personnummer måste skrivas med 12st siffror.</p>",
      "/messages/ssnValidSwe",
      "text",
      "Fel personnummer"
    );
    this.MessageAllowedYearsBornSwe = this.getOrCreate(
      "<p>Ansökningen endast öppen för personer födda år #DATA#</p>",
      "/messages/allowedYearsBornSwe",
      "text",
      "Födda specifikt år"
    );
    // this.MessageFileUploadIsRequired = this.getOrCreate(
    //   "<p>Du måste bifoga minst en fil</p>",
    //   "/messages/fileUploadIsRequired",
    //   "text",
    //   "Filuppladdning krävs"
    // );
    this.MessageEqualYearBorn = this.getOrCreate(
      "<h3>Du har angivit ett felaktigt personnummer<h3/><p>Ditt personnummer måste skrivas med 12st siffror.</p>",
      "/messages/equalYearBorn",
      "text",
      "Enbart födelseår"
    );
    this.MessageAllowedYears = this.getOrCreate(
      "<h3>Du har angivit ett felaktigt personnummer<h3/><p>Ditt personnummer måste skrivas med 12st siffror.</p>",
      "/messages/allowedYears",
      "text",
      "Tillåtna födelseår"
    );
    this.MessageApproved = this.getOrCreate(
      "<p>Du måste godkänna villkoren</p>",
      "/messages/approved",
      "text",
      "Villkor"
    );
    this.MessageValidEmail = this.getOrCreate(
      "<p>Email är inte giltigt format</p>",
      "/messages/validEmail",
      "text",
      "Felaktig email"
    );
    this.MessageBECustomGroupValidation = this.getOrCreate(
      "<p>Du måste välja minst en av verksamheterna</p>",
      "/messages/beCustomGroupValidation",
      "text",
      "Verksamheter"
    );
    this.MessageMinYearAtStart = this.getOrCreate(
      "<p>Du måste vara #DATA# år fyllda vid start</p>",
      "/messages/minYearAtStart",
      "text",
      "Lägsta ålder"
    );
    this.MessageMinSelectedInGroup = this.getOrCreate(
      "/messages/minSelectedInGroup",
      "<p>Du måste välja minst en av verksamheterna</p>",
      "text",
      "Verksamheter"
    );
    this.MessageMinLength = this.getOrCreate(
      "<p>Texten måste vara minst #DATA# tecken långt</p>",
      "/messages/minLength",
      "text",
      "Minsta tecken"
    );
  }

  private getOrCreate(name: string, key: string, type: string, label: string) {
    let property = this.DTO?.metadata?.properties?.find((px) => {
      return px.key === key;
    });
    if (typeof undefined === typeof property) {
      property = new dtos.DynamicProperty();
      property.key = key;
      property.placeholder = name;
      property.label = label;
      property.type = type;
      property.data = name;

      this.DTO?.metadata?.properties?.push(property);
    }
    return property;
  }
}
